import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=13e9a4a8&scoped=true"
import script from "./DetailHeader.vue?vue&type=script&lang=js"
export * from "./DetailHeader.vue?vue&type=script&lang=js"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&id=13e9a4a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e9a4a8",
  null
  
)

export default component.exports